import { gsap, Observer } from "../LibrariesImport";
import { GlobalVariables } from "../GlobalVariables";

export default class Header {

	static init() {
		this.isHomePage = document.body.classList.contains('page-template-template-home');
		this.header = document.querySelector(".header-main");
		if (this.header) {
			this.navMain = this.header.querySelector(".nav-main");
			this.headerClass = this.header.className;
			this.toggleHeader();
			this.initNav();
			this.resize();
		}
		GlobalVariables.resizeCallbacks.push(this);
	}

	static toggleMobileMenu() {
		const toggleMobileMenu = document.querySelector('.nav-main-toggle');

		toggleMobileMenu.addEventListener('click', () => {
			const isOpened = toggleMobileMenu.getAttribute('aria-expanded') === 'false';
			document.body.classList.toggle("nav-main-open", isOpened);
			GlobalVariables.smoother.paused(isOpened);
			toggleMobileMenu.setAttribute('aria-expanded', `${isOpened}`);
			toggleMobileMenu.setAttribute('aria-label', isOpened ? 'Fermer le menu principal' : 'Ouvrir le menu principal');
		});
	}

	static toggleHeader() {
		if (!this.isHomePage) return;

		Observer.create({
			type: "scroll",
			tolerance: 30,
			dragMinimum: 30,
			onStop: () => {
				this.toggleHeaderNormalStyle();
			},
			onStopDelay: 0,
			onUp: () => {
				this.toggleHeaderNormalStyle();
			},
			onDown: () => {
				this.toggleHeaderNormalStyle();
			},
		});

		if (window.innerWidth > 991) {
			setTimeout(() => {
				this.toggleHeaderNormalStyle();
			}, 0);
		}
	}

	static toggleHeaderNormalStyle() {
		if (!this.isHomePage) return;

		this.header.classList.toggle('large', window.scrollY <= document.querySelector(".banner").clientHeight - 350);
		this.setCSSHeaderHeight();
	}

	static initNav() {
		this.toggleMobileMenu();
	}

	static openSubNavBurger(element) {

		element.preventDefault();
		let item = element.target.closest('.menu-item--lev1') || element.target;
		let subNav = item.querySelector('.lev2');

		if (item.classList.contains("subnav-open")) {
			item.classList.remove("subnav-open");
			document.body.classList.remove('subnav-open');
			gsap.to(subNav, {
				height: 0,
				duration: 0.3,
			});
		} else {
			item.classList.add("subnav-open");
			document.body.classList.add('subnav-open');
			gsap.to(subNav, {
				height: subNav.dataset.height,
				duration: 0.3,
			});
		}

	}

	static removeNavMainSectionClass() {

		if (!this.header.classList.contains('header-main-burger') && window.innerWidth > 991) {
			this.removeClassByPrefix(this.navMain, 'section');
		} else {
			this.navMain.classList.add("section");
			this.navMain.classList.add(this.header.dataset.sectionColor);
		}

	}

	static removeClassByPrefix(node, prefix) {
		const regx = new RegExp('\\b' + prefix + '[^ ]*[ ]?\\b', 'g');
		node.className = node.className.replace(regx, '');
		return node;
	}

	static resize() {
		this.removeNavMainSectionClass();
		if (window.innerWidth > 991) {
			document.body.classList.remove("nav-main-open");
			GlobalVariables.smoother.paused(false);
		}
		// set header height as a css variable
		this.setCSSHeaderHeight();
		this.setCSSMenuCTABgWidth();
	}

	static setCSSHeaderHeight = () => document.documentElement.style.setProperty('--header-height', `${this.header.clientHeight}px`);

	/**
	 * Récupérer la largeur du bg visible du cta du menu
	 */
	static setCSSMenuCTABgWidth = () => {
		const bodyWidth = document.body.clientWidth;
		const isMobile = bodyWidth < 992;

		const navMainBtn = document.querySelector('.nav-main-btn');
		const navMainToggle = document.querySelector('.nav-main-toggle');
		const { x: ctaStartX } = navMainBtn.getBoundingClientRect();
		const { x: burgerStartX } = navMainToggle.getBoundingClientRect();

		const ctaContainerWidth = isMobile ? bodyWidth - burgerStartX : bodyWidth - ctaStartX;

		// const width = getComputedStyle(document.querySelector('.nav-main-btn'), '::before').getPropertyValue('width');
		document.documentElement.style.setProperty('--header-cta-width', `${ctaContainerWidth}px`);
	};
}
